<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="900px"
      :fullscreen="fullscreen"
      :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">查看</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12 sm10 lg6>
              <div class="x-text-field">
                <label>申报名称</label>
                <div>{{item.name}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm2 lg2>
              <div class="x-text-field">
                <label>是否初审</label>
                <div>{{ item.ifPreReview}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm2 lg2>
              <div class="x-text-field">
                <label>是否需要匿名活页</label>
                <div>{{item.ifAnonymousLooseLeaf}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm2 lg2>
              <div class="x-text-field">
                <label>审核状态</label>
                <div>{{ item.status ? item.status.name : '' }}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm3 lg3>
              <div class="x-text-field">
                <label>开始日期</label>
                <div>{{item.startDate}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm3 lg3>
              <div class="x-text-field">
                <label>结束日期</label>
                <div>{{item.finishDate}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm3 lg3>
              <div class="x-text-field">
                <label>接收开始日期</label>
                <div>{{item.receiveStartDate}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm3 lg3>
              <div class="x-text-field">
                <label>接收结束日期</label>
                <div>{{item.receiveEndDate}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm3 lg3>
              <div class="x-text-field">
                <label>评审开始日期</label>
                <div>{{item.reviewStartDate}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm3 lg3>
              <div class="x-text-field">
                <label>评审结束日期</label>
                <div>{{item.reviewEndDate}}</div>
              </div>
            </v-flex>

            <v-flex
                xs12
                v-if="item.attachments && item.attachments.length > 0"
            >
              <p class="my-1">附件列表：</p>
              <v-divider/>
              <ol>
                <li v-for="a in item.attachments" :key="a.dbid" class="pt-1">
                  <a :href="`/api/review/attachment/${a.dbid}`" target="_blank">
                    {{a.fileName}}
                    ({{a.size | fileSize }})
                  </a>
                </li>
              </ol>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click.native="visible=false">关闭</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin'

const baseUri = '/api/proj/review/view';
export default {
  mixins: [mixin.view(baseUri)],
  name: "ViewReview",
  data: () => ({
    item: {}
  })
}
</script>

<style scoped>

</style>